

























import { Vue, Component, Prop } from 'vue-property-decorator';

import DaClassBaseCalendar from './calendar/DaClassBaseCalendar.vue';
import DaStudentBaseCalendar from './calendar/DaStudentBaseCalendar.vue';
import { Session } from '../../utils/Session';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';

@Component({ components: { DaClassBaseCalendar, DaStudentBaseCalendar } })
export default class DaLessonReservationCommitCalendarPage extends Vue {
  private classes: { title: string; value: string }[] = [];
  private selectedTeacherId = '';
  private selectedTeacherNickName = '';

  get title() {
    return this.isAll ? '全てのクラスの予約状況' : `${this.selectedTeacherNickName}クラスの予約状況`;
  }

  get isAll() {
    return this.selectedTeacherId === 'all';
  }

  changeTeacher(selected: any) {
    console.log(selected);
    this.selectedTeacherId = selected;
    this.selectedTeacherNickName = this.classes.find((c) => c.value === selected)?.title as string;
  }

  /**
   * クラスの一覧を取得する
   */
  async getClasses() {
    const biz = new DaTeacherService();
    const response = await biz.getTeachers(Session.getSessionBuildingId());
    const daTeachers = response.data
      // 非表示のクラスは表示しない
      .filter((r) => {
        return r.da_teacher.is_shown_admin_page;
      })
      .map((r) => {
        return { title: r.teacher.nickname || '', value: r.teacher.user_id! };
      });
    return [{ title: '全てのクラス', value: 'all' }, ...daTeachers];
  }

  async created() {
    this.classes = await this.getClasses();
    if (this.classes.length > 0) {
      this.selectedTeacherId = this.classes[0].value;
      this.selectedTeacherNickName = this.classes[0].title;
    }
  }
}
